import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "material-ui/Button";
import "jquery-slimscroll/jquery.slimscroll.min";
import IntlMessages from "util/IntlMessages";

class SidenavContent extends Component {
  componentDidMount() {
    const { history } = this.props;
    const $nav = $(this.nav);
    const slideDuration = 250;

    $nav.slimscroll({
      height: "100%",
    });

    const pathname = `#${history.location.pathname}`; // get current path

    $("ul.nav-menu > li.menu").click(function () {
      const menuLi = this;
      $("ul.nav-menu > li.menu").not(menuLi).removeClass("open");
      $("ul.nav-menu > li.menu ul").not($("ul", menuLi)).slideUp(slideDuration);
      $("> ul", menuLi).slideToggle(slideDuration);
      $(menuLi).toggleClass("open");
    });

    $("ul.sub-menu li").click(function (e) {
      let superSubMenu = $(this).parent();
      if (superSubMenu.parent().hasClass("active")) {
        $("li", superSubMenu).not($(this)).removeClass("active");
      } else {
        $("ul.sub-menu li").not($(this)).removeClass("active");
      }

      $(this).toggleClass("active");
      e.stopPropagation();
    });

    const activeLi = $('a[href="' + pathname + '"]'); // select current a element
    const activeNav = activeLi.closest("ul"); // select closest ul
    if (activeNav.hasClass("sub-menu")) {
      activeNav.slideDown(slideDuration);
      activeNav.parent().addClass("open");
      activeLi.parent().addClass("active");
    } else {
      activeLi.parent().addClass("open");
    }
  }
  render() {
    return (
      <ul
        className="nav-menu"
        style={{
          backgroundColor: "#E2E3E5",
        }}
        ref={(c) => {
          this.nav = c;
        }}
      >
        <li className="menu"></li>

        {/* <li className="menu no-arrow">
                    <Button className="void" href="#/app/components/metrics">
                        <img src="./assets/images/ico-metric.png" alt="ico-metric" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp;<span className="nav-text">Metrics</span>
                    </Button>
                </li>
                <li className="menu no-arrow">
                    <Button className="void" href="#/app/components/machineLearning">
                        <img src="./assets/images/ico-machine.png" alt="MachineLearning" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp;<span className="nav-text">Machine Learning</span>
                    </Button>
                </li>
                <li className="menu no-arrow">
                    <Button className="void" href="#/app/components/correlations">
                        <img src="./assets/images/ico-correlation.png" alt="ico-correlation" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp;<span className="nav-text">Correlations</span>
                    </Button>
                </li>
                <li className="menu no-arrow">
                    <Button className="void" href="#/app/components/devices">
                        <img src="./assets/images/ico-device.png" alt="ico-device" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp;<span className="nav-text">Devices</span>
                    </Button>
                </li>
                <li className="menu no-arrow">
                    <Button className="void" href="#/app/components/notifications">
                        <img src="./assets/images/ico-notification.png" alt="ico-notification" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp;<span className="nav-text">Notifications</span>
                    </Button>
                </li> */}
        <li className="menu no-arrow">
          <Button className="void d-flex justify-content-start" href="#/app/components/summary">
            <i className="zmdi zmdi-star text-black icons" aria-hidden="true" />
            {/* <img src="./assets/images/ico-heartbeat.png" alt="heartbeat" width="20" height="20" /> */}
            {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span className="nav-text text-black">Summary</span>
          </Button>
        </li>
        <li className="menu no-arrow">
          <Button className="void d-flex justify-content-start" href="#/app/components/heartbeat">
            <i className="zmdi zmdi-home text-black icons" aria-hidden="true" />
            {/* <img src="./assets/images/ico-heartbeat.png" alt="heartbeat" width="20" height="20" /> */}
            {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span className="nav-text text-black">Device Home</span>
          </Button>
        </li>
        <li className="menu no-arrow">
          <Button className="void d-flex justify-content-start" href="#/app/components/config">
            {/* <img src="./assets/images/ico-metric.png" alt="ico-metric" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
            <i
              className="zmdi zmdi-settings text-black icons"
              aria-hidden="true"
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span className="nav-text text-black">OTA Update</span>
          </Button>
        </li>
        <li className="menu no-arrow">
          <Button className="void d-flex justify-content-start" href="#/app/components/deviceCatalogue">
            {/* <img src="./assets/images/ico-metric.png" alt="ico-metric" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
            <i
              className="zmdi zmdi-view-list-alt text-black icons"
              aria-hidden="true"
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span className="nav-text text-black">Device Catalogue</span>
          </Button>
        </li>
        <li className="menu no-arrow">
          <Button className="void d-flex justify-content-start" href="#/app/components/deviceVitals">
            {/* <img src="./assets/images/ico-metric.png" alt="ico-metric" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
            <i
              className="fa fa-heartbeat text-black mt-1 icons "
              aria-hidden="true"
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span className="nav-text text-black">Device Vitals</span>
          </Button>
        </li>
        <li className="menu no-arrow">
          <Button className="void d-flex justify-content-start" href="#/app/components/alerts">
            {/* <img src="./assets/images/ico-metric.png" alt="ico-metric" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
            <i
              className="zmdi zmdi-alert-triangle text-black icons"
              aria-hidden="true"
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span className="nav-text text-black">Alerts</span>
          </Button>
        </li>
        <li className="menu no-arrow">
          <Button className="void d-flex justify-content-start" href="#/app/components/downloadData">
            {/* <img src="./assets/images/ico-metric.png" alt="ico-metric" width="20" height="20" />
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
            <i
              className="zmdi zmdi-download text-black icons"
              aria-hidden="true"
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span className="nav-text text-black">Download data</span>
          </Button>
        </li>
      </ul>
    );
  }
}

export default withRouter(SidenavContent);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js